<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <div class="about-banner-wrap banner-space about-us-bg position-relative">
                <div class="banner-overlay"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 ml-auto mr-auto">
                            <div class="about-banner-content text-center">
                                <h1 class="mb-15 text-white">Axis Realty Homes For Rent</h1>
                                <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-large-images-wrapper pt-12 pb-4">
                <div class="container">
                    <div class="cybersecurity-about-box">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="cybersecurity-about-text"> 
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <h4 class="heading mb-4">Find the Perfect Home</h4>
                                        </div>                                    
                                        <div class="col-lg-6 text-right">
                                            <router-link :to="`${baseUrl}/apply-for-rental`" class="vs-component vs-button bg-primary vs-button-primary vs-button-filled text-white">Apply Online</router-link>
                                        </div>
                                    </div>
                                    <div class="text mt-8">
                                        We want to make your experience in finding your next dream home an enjoyable one! Find houses for rent in St. Louis and surrounding areas by selecting from our list of rental homes, or by entering your search criteria below. Contact us today and we will help you find the perfect rental property!
                                    </div>                         
                                </div>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>

            <div class="blog-pages-wrapper section-space--pb_100">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 mb-8">
                            <h4 class="heading">3822 Oregon Ave, St Louis, MO 63118</h4>
                        </div>
                        <div class="col-lg-3 order-lg-1 order-1 pr-12">
                            <div class="page-sidebar-content-wrapper small-mt__40 tablet-mt__40">

                                <div class="sidebar-widget widget-blog-recent-post wow move-up">
                                                        
                                    <div class="">
                                        <router-link :to="`${baseUrl}/apply-for-rental`" class="vs-component vs-button w-100 vs-button-primary vs-button-filled text-white text-center">Apply Online</router-link>
                                    </div>

                                    <ul class="mt-8">
                                        <li>
                                            <h5 class="text-color-secondary font-weight--reguler mb-4">Tel: 314 474 5277</h5>
                                        </li>
                                        <li>
                                            <h6 class="mb-4">3822 Oregon Ave, St, <br>MO 63118</h6>
                                        </li>
                                        <li>
                                            <h5 class="text-color-secondary font-weight--reguler mb-4">Rent: $600.00</h5>
                                        </li>
                                        <li>
                                            <h6 class="mb-4"><span class="font-weight--reguler">Type:</span> Apartment</h6>
                                        </li>
                                        <li>
                                            <div class="d-flex mb-4">
                                                <h6 class="w-40" ><span class="font-weight--reguler">Beds:</span> 1</h6><span class="w-20 text-center">|</span><h6 class="w-40 text-right" ><span class="font-weight--reguler">Baths:</span> 2</h6>
                                            </div>
                                        </li>
                                        <li>
                                            <h6 class="mb-8"><span class="font-weight--reguler">Deposit:</span> $600.00</h6>
                                        </li>
                                        <li>
                                            <h6 class="mb-4"><span class="font-weight--reguler">Eligibility:</span></h6>
                                            <ul class="list">
                                                <li class="flex mb-3 justify-between">
                                                    <span class="flex items-start">                                                        
                                                        <span class="w-8">
                                                            <span class="inline-block h-3 w-3 rounded-full mr-2 mt-2 bg-primary"></span>
                                                        </span>
                                                        <span class="font-weight--reguler">Minimum income of $1,800 per month</span>
                                                    </span>
                                                </li>
                                                <li class="flex mb-3 justify-between">
                                                    <span class="flex items-start">
                                                        <span class="w-16">
                                                            <span class="inline-block h-3 w-3 rounded-full mr-2 mt-2 bg-primary"></span>
                                                        </span>
                                                        <span class="font-weight--reguler">Rental Assistance Voucher from any reputable organizations (HUD, Section 8 etc.,)</span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>

                                </div>

                            </div>
                        </div>
                        <div class="col-lg-5 order-lg-2 order-1">
                            <div class="main-blog-wrap">
                                <div class="single-blog-item">
                                    <div class="post-feature blog-thumbnail wow move-up">
                                        <img class="img-fluid" src="@/assets/images/properties/3822-Oregon-Avenue-.num.-Fl-1ST-Saint-Louis.jpg" alt="Property Images">
                                        <!-- <div class="row gallery-row">
                                            <div class="col-lg-3">
                                            <img src="@/assets/images/properties/thumb-1.jpg" style="width:100%" onclick="openModal();currentSlide(1)" class="hover-shadow cursor">
                                            </div>
                                            <div class="col-lg-3">
                                            <img src="@/assets/images/properties/thumb-2.jpg" style="width:100%" onclick="openModal();currentSlide(2)" class="hover-shadow cursor">
                                            </div>
                                            <div class="col-lg-3">
                                            <img src="@/assets/images/properties/thumb-3.jpg" style="width:100%" onclick="openModal();currentSlide(3)" class="hover-shadow cursor">
                                            </div>
                                            <div class="col-lg-3">
                                            <img src="@/assets/images/properties/thumb-4.jpg" style="width:100%" onclick="openModal();currentSlide(4)" class="hover-shadow cursor">
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 order-lg-3 order-1">
                            <div class="business-solution-form-wrap">
                                <div class="contact-title text-center section-space--mb_40">
                                    <h5 class="mb-10">Inquire Now</h5>
                                </div>
                                <form>
                                    <div class="contact-form__two contact-form">
                                        <div class="contact-inner">
                                            <vs-input class="w-full" v-validate="'required|min:2'" placeholder="Name" name="name" v-model="sendMessage.name" />
                                            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                                        </div>
                                        <div class="contact-inner">
                                            <vs-input class="w-full" v-validate="'required|email'" placeholder="Email" name="email" v-model="sendMessage.email" />
                                            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                                        </div>
                                        <div class="contact-inner">
                                            <vs-input class="w-full" v-validate="'required|min:10|max:10'" placeholder="Phone" name="phone" v-model="sendMessage.phone" />
                                            <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                                        </div>
                                        <div class="contact-inner">
                                            <vs-textarea class="w-full mb-0" v-validate="'required'" placeholder="Comment" name="comment" v-model="sendMessage.message" />
                                            <span class="text-danger text-sm" v-show="errors.has('comment')">{{ errors.first('comment') }}</span>
                                        </div>
                                        <div class="comment-submit-btn text-center">
                                                <vs-button type="filled" @click.prevent="submitForm" class="">Submit</vs-button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-lg-12 ht-tab-wrap mt-40">
                            <div class="row">
                                <div class="col-lg-12">
                                    <vs-tabs alignment="fixed">
                                        <vs-tab label="Map">
                                            <div class="google-map">
                                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3118.7314262480504!2d-90.23465568433167!3d38.58603217284159!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87d8b40dbf1e44bf%3A0xb4cb77e5ffe9f8b1!2s3822%20Oregon%20Ave%2C%20St.%20Louis%2C%20MO%2063118%2C%20USA!5e0!3m2!1sen!2sin!4v1606807407006!5m2!1sen!2sin" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                                            </div>
                                        </vs-tab>
                                    </vs-tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
            
        <the-footer />
    </div>
</template>

<script>
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'
import Contact from '@/js/password.js'

export default {
  components: {
    TheHeader,
    TheFooter
  },
  data () {
    return {
      sendMessage: {
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    }
  },
  methods: {
    submitForm () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          Contact.addContact(this, this.sendMessage)
        } else {
          console.log('errors', this.errors)
        }
        // this.sendMessage = ''
      })
    },
    contactAdded (data) {
      this.$vs.loading.close()
      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: 'Contact',
        text: data.return_message,
        accept: null
      })
    },
    contactNotAdded (message) {
      this.$vs.loading.close()
      this.$vs.dialog({
        type: 'alert',
        color: 'danger',
        title: 'Contact',
        text: message,
        accept: null
      })
    }
  },
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, ('/'))
    }
  }

}
</script>